import { render } from "./ExpandableCell.vue?vue&type=template&id=5f75572e"
import script from "./ExpandableCell.vue?vue&type=script&lang=js"
export * from "./ExpandableCell.vue?vue&type=script&lang=js"

import "./ExpandableCell.vue?vue&type=style&index=0&id=5f75572e&lang=scss"

import exportComponent from "/builds/boikovky/medsafe-stat-new/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__